module.exports = __webpack_public_path__ + "img/product-shansuan-zsyy-02.0ddafb5b.png";